export const realEstateNavItems = {
  services: 'Послуги',
  landPlot: 'Земельна ділянка',
};

export const realEstateSecondDescription =
  "Наша мета - допомогти вам знайти свій домівку мрії, незалежно від того, чи шукаєте ви купити, чи орендувати. Ми пропонуємо широкий вибір нерухомості в різних місцях та стилях, що дозволить вам знайти щось, що підходить вам за потребами та бюджетом. Подивіться на наші рекомендовані об'єкти нижче або використовуйте рядок пошуку, щоб знайти певний тип нерухомості чи місцезнаходження. Якщо у вас виникли запитання, зв'яжіться з нами.";
